import React, { useState, useEffect } from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import ExcelJS from "exceljs";

import { styled } from "@mui/styles";
import makeStyles from "@mui/styles/makeStyles";
import {
  Stack,
  Container,
  Tabs,
  Tab,
  Grid,
  TextField,
  Select,
  FormControl,
  MenuItem,
  useMediaQuery,
  useTheme,
  Box,
  Typography,
  IconButton,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import {
  DownloadRounded as DownloadRoundedIcon,
  ArrowBack as ArrowBackIcon,
  DriveEta as DriveEtaIcon,
  FilterAlt as FilterAltIcon,
} from "@mui/icons-material";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { width } from "@mui/system";

import RightDrawer from "../../shared/rightDrawer";
import utils from "../../../../utils";

import CrossArea from "./crossArea";
import DetailCrossAreaCar from "./crossArea/detailCrossAreaCar";
import EditDetailCrossAreaCarBooking from "./crossArea/editDetail/index";

import InArea from "./inArea";
import DetailInAreaCar from "./inArea/detailInAreaCar";
import EditDetailInAreaCarBooking from "./inArea/editDetail";

import CrossAreaPool from "./crossAreaPool";
import DetailCrossAreaCarPool from "./crossAreaPool/detailCrossAreaCarPool";
import EditDetailCrossAreaCarPool from "./crossAreaPool/editDetail";

import DeliveryItems from "./deliveryItems";
import DetailDeliveryCar from "./deliveryItems/detailDeliveryCar";
import EditDetailDeliveryitemCar from "./deliveryItems/editDetail";

import DeliverySampleShuttleCar from "./deliverySampleShuttle";
import DetailDeliverySampleShuttle from "./deliverySampleShuttle/detailDeliverySampleShuttle";
import FormDetailFlight from "../../user/sampleshuttle/NewSample/formDetailFight";
import EditDetailDeliverySampleShuttle from "./deliverySampleShuttle/editDetail";
import CreateExcelDeliverySampleShuttle from "./deliverySampleShuttle/createExcelDeliverySampleShuttle";
import FilterDeliverySampleShuttle from "./deliverySampleShuttle/filterDeliverySampleShuttle";

import DetailDriverPeer2Peer from "./DetailDriverPeer2peer";

import ShowMapAllDriver from "./showMapAllDriver";

import BetweenSiteCarManage from "./betweenSiteCar";
import DetailBetweenSite from "./betweenSiteCar/detailBetweenSite";
import EditDetailBetweenSite from "./betweenSiteCar/editDetail";

import { getUserProfile } from "../../../../actions/user";
import { getEmployeesByCompany } from "../../../../actions/employee";
import { getAllDriver } from "../../../../actions/user";
import { getAllVehicles } from "../../../../actions/vehicle";
import { getAllVehicleBrandsAndModels } from "../../../../actions/vehicleBrandAndModel";
import {
  getCrossAreaCarBookingByStartDate,
  getCrossAreaCarBookingByStartDateAndEndDate,
} from "../../../../actions/crossAreaCarBooking";
import {
  getInAreaCarBookingByStartDate,
  getInAreaCarBookingByStartDateAndEndDate,
} from "../../../../actions/inAreaCarBooking";
import {
  getDeliveryCarBookingByStartDate,
  getDeliveryCarBookingByStartDateAndEndDate,
} from "../../../../actions/deliveryCarBooking";
import { getBetweenSiteByAdminFilter } from "../../../../actions/betweenSiteCarBooking";
import {
  getCrossAreaCarPoolBookingByStartDate,
  getCrossAreaCarPoolBookingByStartDateAndEndDate,
} from "../../../../actions/crossAreaCarPoolBooking";
import { getDeliverySampleshuttleByAdminFilter } from "../../../../actions/deliverySampleshuttle";

import driverEmergencyService from "../../../../services/driverEmergency.service";
import SiteService from "../../../../services/site.service";
import employeeService from "../../../../services/employee.service";
import userService from "../../../../services/user.service";

import { name } from "dayjs/locale/th";
import dayjs from "dayjs";
require("dayjs/locale/th");
dayjs.locale("th");

const useStyles = makeStyles((theme) => ({
  DatePicker: {
    marginRight: "15px",
    [theme.breakpoints.down("md")]: {
      marginRight: "0px",
    },
  },
  IconCar: {
    fontSize: "36px",
    marginRight: "10px",
    color: theme.palette.primary.main,
  },
}));

const DivCoverReturn = styled("div")(({ theme }) => ({
  display: "flex",

  flexDirection: "column",
  marginTop: "20px",
  height: "calc(100% - 64px)",

  "& .ButtonTypeNotClicked": {
    backgroundColor: "#B2BABB ",
    color: "white",
    fontWeight: "bold",
    ["&:hover"]: {
      borderBottom: "0px",
      backgroundColor: "#D5DBDB",
    },
  },
}));

const HeaderOfPage = styled("div")({
  display: "flex",
  flexDirection: "column",
  marginBottom: "20px",
});

const Root = styled("div")(({ theme }) => ({
  paddingInline: "8vw",
  height: "100%",
  [theme.breakpoints.down("sm")]: {
    paddingInline: "0",
    marginLeft: "0",
    width: "100%",
  },
}));

const TabsStyled = styled(Tabs)({
  "& .MuiTab-root": {
    fontSize: "16px",
    fontWeight: "500",
    minWidth: "150px",
    minHeight: "60px",
  },
  "& .MuiTabs-scroller .PrivateTabIndicator-colorSecondary-34": {
    height: "3px",
  },
});

const TabStyled = styled(Tab)({
  fontSize: "20px",
  height: "60px",
});
const Image = styled("img")({
  width: "100%",
  height: "80%",
});

const PartOfContent = styled("div")({
  width: "100%",
  height: "calc(100% - 80px)",
});
const BackButton = styled(IconButton)(({ theme }) => ({
  color: "black",
  "&:hover": {
    backgroundColor: "inherit",
  },
  "& .Icon": {
    fontSize: "30px",
  },
}));

const DivTitle = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  [theme.breakpoints.down("md")]: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
  },
}));

const GridTitle = styled(Grid)(({ theme }) => ({
  paddingBlock: "40px",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",

  [theme.breakpoints.down("md")]: {
    display: "flex",
    flexDirection: "column",
    alignItems: "start",
    justifyContent: "center",
    gap: "20px",
  },
}));

const DivButton = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  [theme.breakpoints.down("md")]: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
  },
}));

const Title = styled(Typography)({
  textAlign: "center",
  fontSize: "30px",
});

const Text = styled(Typography)({
  fontSize: "15px",
});

// Excel header
const head_CrossArea = [
  "Booking ID",
  "Name",
  "Telephone",
  "Email",
  "Section",
  "Department",
  "Passenger",
  "Passenger (Return)",
  "Flight",
  "From",
  "To",
  "Departure Date",
  "Start Time",
  "End Time",
  "From (Return)",
  "To (Return)",
  "Date (Return)",
  "Start Time (Return)",
  "End Time (Return)",
  "Purpose",
  "Driver Name",
  "Driver Telephone",
  "Vehicle Type",
  "Model",
  "Plate No",
  "Approver Name",
  "Approver Department",
  "Approver Company",
  "Total Price",
  "Management Car Status",
  "Approval Status",
];

const head_CrossAreaPool = [
  "Booking ID",
  "Name",
  "Telephone",
  "Email",
  "Section",
  "Department",
  "Passenger",
  "Passenger (Return)",
  "Flight",
  "From",
  "To",
  "Departure Date",
  "From (Return)",
  "To (Return)",
  "Date (Return)",
  "Driver Name",
  "Driver Telephone",
  "Model",
  "Plate No",
  "Management Car Status",
  "Approval Status",
];

const head_InArea = [
  "Booking ID",
  "Name",
  "Telephone",
  "Email",
  "Section",
  "Department",
  "Company",
  "Cost Center",
  "Cost Element",
  "Passenger",
  "Flight",
  "From",
  "To",
  "GA Site",
  "Departure Date",
  "Start Time",
  "End Time",
  "Purpose",
  "Note",
  "Driver Name",
  "Driver Telephone",
  "Model",
  "Plate No",
  "Approver Name",
  "Approver Department",
  "Approver Company",
  "Management Car Status",
  "Approval Status",
];

const head_Delivery = [
  "Booking ID",
  "Name",
  "Telephone",
  "Email",
  "Section",
  "Department",
  "From",
  "To",
  "Date",
  "Start Time",
  "End Time",
  "Type Product",
  "Weight Product",
  "Purpose",
  "Detail",
  "Note",
  "Name Recipient",
  "Telephone Recipient",
  "Driver Name",
  "Driver Telephone",
  "Model",
  "Plate No",
  "Total Price",
  "Management Car Status",
  "Approval Status",
];

const head_BetweenSite = [
  "Booking ID",
  "Name",
  "Telephone",
  "Email",
  "Section",
  "Department",
  "Company",
  "From",
  "To",
  "Date",
  "Name Driver",
  "Telephone Driver",
];

const CarManagement = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const { user: currentUser } = useSelector((state) => state.auth);
  const { result: userProfile } = useSelector((state) => state.userProfile);
  const { result: allDriver } = useSelector((state) => state.drivers);
  const { result: allVehicles } = useSelector((state) => state.vehicles);
  const { result: listVehicleBrandAndModel } = useSelector(
    (state) => state.vehicleBrandsAndModels
  );

  const { result: allBookingCrossArea, isFetching: isFetchingCrossArea } =
    useSelector((state) => state.crossAreaCar);
  const {
    result: allBookingCrossAreaPool,
    isFetching: isFetchingCrossAreaPool,
  } = useSelector((state) => state.crossAreaCarPool);
  const { result: allBookingInArea, isFetching: isFetchingInArea } =
    useSelector((state) => state.inAreaCar);
  const { result: allBookingDelivery, isFetching: isFetchingDelivery } =
    useSelector((state) => state.deliveryCar);
  const {
    result: allBookingDeliverySampleShuttle,
    isFetching: isFetchingDeliverySampleShuttleCar,
  } = useSelector((state) => state.deliverySampleShuttleCar);
  const { result: allBookingBetweenSite, isFetching: isFetchingBetweenSite } =
    useSelector((state) => state.betweenSiteCar);

  const [typeOfManagement, setTypeOfManagement] = useState("cross_area");
  const [startDate, setStartDate] = useState(() => {
    const date = new Date(); // Get current date
    date.setMonth(date.getMonth() - 1); // Subtract 1 month
    return date;
  });
  const [endDate, setEndDate] = useState(null);
  const [company, setCompany] = useState(userProfile?.companyName);
  const [loading, setLoading] = useState(false);

  const onChangeTab = (event, page) => {
    props.history.push("/admin/car_management/" + page);
    setTypeOfManagement(page);
  };

  const onClickGoBack = () => {
    props.history.push("/admin/car_booking_management");
  };

  // Excel transform data
  const setFormatCrossArea = (data) => {
    let temp = [];
    data.forEach((booking) => {
      temp.push({
        idCrossAreaCarBooking: booking.idCrossAreaCarBooking,
        name: booking.name,
        telephoneMobile: booking.telephoneMobile,
        email: booking.email,
        section: booking.section,
        department: booking.department,
        numberOfPassenger: `${booking.numberOfPassenger} คน`,
        numberOfPassengerReturn:
          booking.flight === "oneWay"
            ? null
            : `${booking.numberOfPassengerReturn} คน`,
        flight: booking.flight === "oneWay" ? "เที่ยวเดียว" : "ไป-กลับ",
        fromPlace: booking.fromPlace,
        toPlace: booking.toPlace,
        departureDate: dayjs(booking.departureDate).format("D MMM YYYY"),
        startTime: dayjs(booking.startTime).format("HH:mm น."),
        endTime: dayjs(booking.endTime).format("HH:mm น."),
        fromPlaceReturn:
          booking.flight === "twoWay" ? booking.fromPlaceReturn : null,
        toPlaceReturn:
          booking.flight === "twoWay" ? booking.toPlaceReturn : null,
        returnDate:
          booking.flight === "twoWay" && booking.returnDate
            ? dayjs(booking.returnDate).format("D MMM YYYY")
            : null,
        returnStartTime:
          booking.flight === "twoWay" && booking.returnStartTime
            ? dayjs(booking.returnStartTime).format("HH:mm น.")
            : null,
        returnEndTime:
          booking.flight === "twoWay" && booking.returnEndTime
            ? dayjs(booking.returnEndTime).format("HH:mm น.")
            : null,
        purpose: booking.purpose,
        nameDriver: booking.nameDriver,
        phoneDriver: booking.phoneDriver,
        vehicleTypeNameTH: booking.vehicleTypeNameTH,
        model: booking.model,
        plate_No: booking.plate_No,
        nameApproved: booking.Approver
          ? booking.Approver.firstname_TH + " " + booking.Approver.lastname_TH
          : null,
        departmentApproved: booking.Approver
          ? booking.Approver.departmentName
          : null,
        companyApproved: booking.Approver ? booking.Approver.companyName : null,
        totalPrice: booking.totalPrice
          ? `${utils.numberWithCommas(booking.totalPrice)} บาท`
          : null,
        statusManageCar:
          booking.statusManageCar === "Success" ? "จัดรถแล้ว" : "รอดำเนินการ",
        statusApproved:
          booking.statusApproved === null
            ? "รอดำเนินการ"
            : booking.statusApproved === "Approved"
            ? "อนุมัติ"
            : "ไม่อนุมัติ",
      });
    });
    return temp;
  };

  const setFormatCrossAreaPool = (data) => {
    let temp = [];
    data.forEach((booking) => {
      temp.push({
        idCrossAreaCarPoolBooking: booking.idCrossAreaCarPoolBooking,
        name: booking.name,
        telephoneMobile: booking.telephoneMobile,
        email: booking.email,
        section: booking.section,
        department: booking.department,
        numberOfPassenger: `${booking.numberOfPassenger} คน`,
        numberOfPassengerReturn:
          booking.flight === "oneWay"
            ? null
            : `${booking.numberOfPassengerReturn} คน`,
        flight: booking.flight === "oneWay" ? "เที่ยวเดียว" : "ไป-กลับ",
        fromPlace: booking.fromPlace,
        toPlace: booking.toPlace,
        departureDate: dayjs(booking.departureDate).format("D MMM YYYY"),
        fromPlaceReturn:
          booking.flight === "twoWay" ? booking.fromPlaceReturn : null,
        toPlaceReturn:
          booking.flight === "twoWay" ? booking.toPlaceReturn : null,
        returnDate:
          booking.flight === "twoWay"
            ? dayjs(booking.returnDate).format("D MMM YYYY")
            : null,
        nameDriver: booking.nameDriver,
        phoneDriver: booking.phoneDriver,
        model: booking.vehicle ? booking.vehicle.model : null,
        plate_No: booking.plate_No,
        statusManageCar:
          booking.statusManageCar === "Success" ? "จัดรถแล้ว" : "รอดำเนินการ",
        statusApproved:
          booking.statusApproved === null
            ? "รอดำเนินการ"
            : booking.statusApproved === "Approved"
            ? "อนุมัติ"
            : "ไม่อนุมัติ",
      });
    });
    return temp;
  };

  const setFormatInArea = (data) => {
    let temp = [];
    data.forEach((booking) => {
      temp.push({
        idinAreaCarBooking: booking.idinAreaCarBooking,
        name: booking.name,
        telephoneMobile: booking.telephoneMobile,
        email: booking.email,
        section: booking.section,
        department: booking.department,
        company: booking.company,
        costCenter: booking.costCenter,
        costElement: booking.costElement,
        numberOfPassenger: `${booking.numberOfPassenger} คน`,
        flight: booking.flight === "oneWay" ? "เที่ยวเดียว" : "ไป-กลับ",
        fromPlace: booking.fromPlace,
        toPlace: booking.toPlace,
        gaSite: booking.gaSite,
        departureDate: dayjs(booking.departureDate).format("D MMM YYYY"),
        startTime: dayjs(booking.startTime).format("HH:mm น."),
        endTime: dayjs(booking.endTime).format("HH:mm น."),
        purpose: booking.purpose,
        note: booking.note,
        nameDriver: booking.nameDriver,
        phoneDriver: booking.phoneDriver,
        model: booking.model,
        plate_No: booking.plate_No,
        nameApproved: booking.nameApproved,
        departmentApproved: booking.departmentApproved,
        companyApproved: booking.companyApproved,
        statusManageCar:
          booking.statusManageCar === "Success" ? "จัดรถแล้ว" : "รอดำเนินการ",
        statusApproved:
          booking.statusApproved === "in progress" ||
          booking.statusApproved === null
            ? "รอดำเนินการ"
            : booking.statusApproved === "Approved"
            ? "อนุมัติ"
            : "ไม่อนุมัติ",
      });
    });
    return temp;
  };

  const setFormatDelivery = (data) => {
    let temp = [];
    data.forEach((booking) => {
      temp.push({
        idDeliveryCarBooking: booking.idDeliveryCarBooking,
        name: booking.name,
        telephoneMobile: booking.telephoneMobile,
        email: booking.email,
        section: booking.section,
        department: booking.department,
        fromPlace: booking.fromPlace,
        toPlace: booking.toPlace,
        date: dayjs(booking.date).format("D MMM YYYY"),
        startTime: dayjs(booking.startTime).format("HH:mm น."),
        endTime: dayjs(booking.endTime).format("HH:mm น."),
        typeProduct: booking.typeProduct,
        weightProduct: booking.weightProduct
          ? `${utils.numberWithCommas(booking.weightProduct)} KG`
          : null,
        purpose: booking.purpose,
        detail: booking.detail,
        note: booking.note,
        nameRecipient: booking.nameRecipient,
        telephoneMobileRecipient: booking.telephoneMobileRecipient,
        nameDriver: booking.nameDriver,
        phoneDriver: booking.phoneDriver,
        model: booking.model,
        plate_No: booking.plate_No,
        costBooking: booking.costBooking
          ? `${utils.numberWithCommas(booking.costBooking)} บาท`
          : null,
        statusManageCar:
          booking.statusManageCar === "Success" ? "จัดรถแล้ว" : "รอดำเนินการ",
        statusApproved:
          booking.statusApproved === null
            ? "รอดำเนินการ"
            : booking.statusApproved === "Approved"
            ? "อนุมัติ"
            : "ไม่อนุมัติ",
      });
    });
    return temp;
  };

  const setFormatBetweenSite = (data) => {
    let temp = [];
    data.forEach((booking) => {
      temp.push({
        idBetweenSiteCar: booking.idBetweenSiteCar,
        name: `${booking.user.firstname_TH} ${booking.user.lastname_TH}`,
        telephoneMobile: booking.user.telephoneMobile,
        email: booking.user.email,
        section: booking.user.sectionName,
        department: booking.user.departmentName,
        company: booking.user.companyName,
        fromPlace: `Site${booking.gettingPlace.noSite}: ${booking.gettingPlace.nameSite}`,
        toPlace: `Site${booking.toPlace.noSite}: ${booking.toPlace.nameSite}`,
        date: dayjs(booking.date).format("D MMM YYYY"),
        nameDriver: booking.driver.fNameThai,
        phoneDriver: booking.driver.mobileNumber,
      });
    });
    return temp;
  };

  const [openDeliverySampleListDownload, setOpenDeliverySampleListDownload] =
    useState(false);

  const onClickDownload = () => {
    setLoading(true);
    if (typeOfManagement === "cross_area" && allBookingCrossArea) {
      const data = setFormatCrossArea(allBookingCrossArea);
      CompensateXlsx(head_CrossArea, data);
    } else if (
      typeOfManagement === "cross_area_pool" &&
      allBookingCrossAreaPool
    ) {
      const data = setFormatCrossAreaPool(allBookingCrossAreaPool);
      CompensateXlsx(head_CrossAreaPool, data);
    } else if (typeOfManagement === "in_area" && allBookingInArea) {
      const data = setFormatInArea(allBookingInArea);
      CompensateXlsx(head_InArea, data);
    } else if (typeOfManagement === "delivery" && allBookingDelivery) {
      const data = setFormatDelivery(allBookingDelivery);
      CompensateXlsx(head_Delivery, data);
    } else if (
      typeOfManagement === "delivery_sample_shuttle" &&
      allBookingDeliverySampleShuttle
    ) {
      setLoading(false);
      setOpenDeliverySampleListDownload(true);
    } else if (
      typeOfManagement === "between_site_car" &&
      allBookingBetweenSite
    ) {
      const data = setFormatBetweenSite(allBookingBetweenSite);
      CompensateXlsx(head_BetweenSite, data);
    }
  };

  useEffect(() => {
    if (userProfile === null) {
      dispatch(getUserProfile(currentUser.idUser));
    }
    if (!allDriver) {
      dispatch(getAllDriver());
    }
    if (!allVehicles) {
      dispatch(getAllVehicles());
    }
    if (!listVehicleBrandAndModel) {
      dispatch(getAllVehicleBrandsAndModels());
    }

    let path = props.history.location.pathname.split("/");
    if (path[path.length - 1] === "cross_area") {
      setTypeOfManagement("cross_area");
    }
    if (path[path.length - 1] === "cross_area_pool") {
      setTypeOfManagement("cross_area_pool");
    }
    if (path[path.length - 1] === "in_area") {
      setTypeOfManagement("in_area");
    }
    if (path[path.length - 1] === "delivery") {
      setTypeOfManagement("delivery");
    }
    if (path[path.length - 1] === "delivery_sample_shuttle") {
      setTypeOfManagement("delivery_sample_shuttle");
    }
    if (path[path.length - 1] === "peer_to_peer") {
      setTypeOfManagement("peer_to_peer");
    }
    if (path[path.length - 1] === "between_site_car") {
      setTypeOfManagement("between_site_car");
    }
    if (path[path.length - 1] === "showMapAllDriver") {
      setTypeOfManagement("showMapAllDriver");
    }
    driverEmergencyService
      .getDriverEmergencyThatIsNotFinish()
      .then((res) => {});
  }, []);

  useEffect(() => {
    props.history.push("/admin/car_management/" + typeOfManagement);

    if (typeOfManagement === "delivery_sample_shuttle") {
      // For delivery sample shuttle
      const defaultFilters = {
        sender: [],
        senderText: "",
        receiver: [],
        receiverText: "",
        driver: [],
        driverText: "",
        sendLocation: [],
        receiveLocation: [],
        startDate: startDate,
        endDate: null,
      };
      setFormData(defaultFilters);
      if (defaultFilters) {
        dispatch(getDeliverySampleshuttleByAdminFilter(defaultFilters));
      }
    }

    // For other type of management
    if (endDate) {
      let date = {
        startDate: new Date(startDate),
        endDate: new Date(endDate),
      };
      if (typeOfManagement === "cross_area") {
        dispatch(getCrossAreaCarBookingByStartDateAndEndDate(date));
      } else if (typeOfManagement === "in_area") {
        dispatch(getInAreaCarBookingByStartDateAndEndDate(date));
      } else if (typeOfManagement === "delivery") {
        dispatch(getDeliveryCarBookingByStartDateAndEndDate(date));
      } else if (typeOfManagement === "between_site_car") {
        dispatch(
          getBetweenSiteByAdminFilter({
            startDate: date.startDate,
            endDate: date.endDate,
          })
        );
      } else if (typeOfManagement === "cross_area_pool") {
        dispatch(getCrossAreaCarPoolBookingByStartDateAndEndDate(date));
      }
    } else {
      let date = {
        startDate: new Date(startDate),
      };
      if (typeOfManagement === "cross_area") {
        dispatch(getCrossAreaCarBookingByStartDate(date));
      } else if (typeOfManagement === "in_area") {
        dispatch(getInAreaCarBookingByStartDate(date));
      } else if (typeOfManagement === "delivery") {
        dispatch(getDeliveryCarBookingByStartDate(date));
      } else if (typeOfManagement === "between_site_car") {
        dispatch(getBetweenSiteByAdminFilter({ startDate: date.startDate }));
      } else if (typeOfManagement === "cross_area_pool") {
        dispatch(getCrossAreaCarPoolBookingByStartDate(date));
      }
    }
  }, [startDate, endDate, typeOfManagement]);

  const CompensateXlsx = (headerValues, data) => {
    const file_name = `${typeOfManagement}_Booking`;
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet(file_name);

    const headerRow = worksheet.addRow(headerValues);
    headerRow.height = 50; // ปรับความสุงของ header cell

    const headerStyle1 = {
      font: {
        bold: true,
        size: 18,
        name: "TH SarabunPSK",
        color: { argb: "FFFFFF" },
      },
      alignment: { horizontal: "center", vertical: "middle" },
      fill: {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "002060" },
      },
    };

    // ตกแต่งตัวอักษร, สีของ cell แต่ละช่อง
    headerRow.eachCell((cell) => {
      cell.style = headerStyle1; // ตัวแปรตกแต่ง cell จากข้างบน
      cell.border = {
        top: { style: "thin", color: { argb: "000000" } },
        left: { style: "thin", color: { argb: "000000" } },
        bottom: { style: "thin", color: { argb: "000000" } },
        right: { style: "thin", color: { argb: "000000" } },
      };
    });

    const colWidths = Object.keys(data[0]).map((key) => ({
      key: key,
      width: 30, // setting a fixed width for each key
    }));

    // Set column widths
    colWidths.forEach((col, index) => {
      worksheet.getColumn(index + 1).width = col.width;
    });

    // นำค่ามาแสดง เอาค่าที่แสดงใส่ให้ตรงตามตำแหน่งของ header
    data &&
      data.forEach((item) => {
        const row = Object.values(item).map((value) =>
          value === null || value === undefined || value === "" ? "-" : value
        );
        const excelRow = worksheet.addRow(row);

        const contentStyle = {
          font: { size: 18, name: "TH SarabunPSK" },
          alignment: { horizontal: "center", vertical: "middle" },
        };

        // ตกแต่ง cell เหมือนกับ headerStyle1
        excelRow.eachCell((cell) => {
          cell.style = contentStyle;
          cell.border = {
            top: { style: "thin", color: { argb: "000000" } },
            left: { style: "thin", color: { argb: "000000" } },
            bottom: { style: "thin", color: { argb: "000000" } },
            right: { style: "thin", color: { argb: "000000" } },
          };
        });
      });

    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${file_name}.xlsx`;
      a.click();
      URL.revokeObjectURL(url);
      setLoading(false);
    });
  };

  // For filter delivery sample shuttle list
  const { result: allEmployees } = useSelector((state) => state.employees);
  const { result: currentUserProfile } = useSelector(
    (state) => state.userProfile
  );
  const [allSite, setAllSite] = useState([]);

  useEffect(async () => {
    SiteService.getAllSiteLocations().then((res) => {
      if (res.data) {
        setAllSite(res.data);
      }
    });
    if (!allEmployees) {
      await employeeService.getEmployeesById(currentUser.idUser).then((res) => {
        if (res.data) {
          dispatch(getEmployeesByCompany(res.data[0].idCompany));
        }
      });
    }
    if (!allDriver) {
      await userService.getAllDriver(currentUser.idUser);
    }
    if (!currentUserProfile) {
      const curData = await dispatch(getUserProfile(currentUser.idUser));
    }
  }, []);

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [formData, setFormData] = useState("");
  const [formDataPreviousSearch, setFormDataPreviousSearch] = useState("");

  const handleFilter = (filters) => {
    const prepareFormData = () => {
      return {
        ...filters,
        sender: filters.sender.map((item) => item.idEmployees),
        receiver: filters.receiver.map((item) => item.idEmployees),
        driver: filters.driver.map((item) => item.idUser),
      };
    };
    dispatch(getDeliverySampleshuttleByAdminFilter(prepareFormData()));
    setFormDataPreviousSearch(filters);
    setFormData(prepareFormData());
    setIsDrawerOpen(false);
  };

  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up("md"));

  return (
    <Container maxWidth="xl">
      <Root>
        <DivCoverReturn className="page">
          <HeaderOfPage>
            <Grid container>
              <GridTitle item xs={12}>
                <DivTitle>
                  <BackButton disableRipple onClick={onClickGoBack}>
                    <ArrowBackIcon
                      className="Icon"
                      style={{ color: "#99A8B2" }}
                    />
                  </BackButton>
                  {isMd && <DriveEtaIcon className={`${classes.IconCar}`} />}
                  <Typography variant="h4">จัดการรถ</Typography>
                  {!isMd && <DriveEtaIcon className={`${classes.IconCar}`} />}
                </DivTitle>
                <DivButton>
                  <LoadingButton
                    loading={
                      loading ||
                      isFetchingBetweenSite ||
                      isFetchingCrossArea ||
                      isFetchingInArea ||
                      isFetchingDelivery ||
                      isFetchingDeliverySampleShuttleCar
                    }
                    disabled={typeOfManagement === "showMapAllDriver"}
                    loadingPosition="start"
                    startIcon={<DownloadRoundedIcon />}
                    variant="outlined"
                    onClick={onClickDownload}
                  >
                    ดาวน์โหลด
                  </LoadingButton>
                </DivButton>
              </GridTitle>
            </Grid>
            <RightDrawer
              header={"ดาวน์โหลด"}
              isDrawerOpen={openDeliverySampleListDownload}
              setIsDrawerOpen={setOpenDeliverySampleListDownload}
            >
              <CreateExcelDeliverySampleShuttle
                allBookingDeliverySampleShuttle={
                  allBookingDeliverySampleShuttle
                }
                openDeliverySampleListDownload={openDeliverySampleListDownload}
              />
            </RightDrawer>
            <Grid
              container
              sx={(theme) => ({
                backgroundColor: "rgb(255, 255, 255)",
                height: "fit-content",
                color: "rgb(33, 43, 54)",
                boxShadow: "rgba(90, 114, 123, 0.11) 0px 7px 30px 0px",
                overflow: "hidden",
                transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1)",
                borderRadius: "20px",
                marginBottom: "20px",
                padding: "25px 30px 25px 30px",
                borderRadius: "15px",
                display: "flex",
                gap: "1rem",
              })}
            >
              <Grid
                container
                sx={(theme) => ({
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "end",
                  [theme.breakpoints.down("md")]: {
                    gap: "1rem",
                  },
                })}
              >
                <Grid
                  item
                  xs={12}
                  md={typeOfManagement === "delivery_sample_shuttle" ? 9 : 5}
                  lg={typeOfManagement === "delivery_sample_shuttle" ? 10 : 5}
                >
                  <Stack>
                    <Text>ชื่อบริษัท</Text>

                    {userProfile && (
                      <FormControl variant="outlined" fullWidth>
                        <Select
                          placeholder="เลือกบริษัท"
                          id="company"
                          defaultValue={userProfile.companyName}
                          onChange={(e) => setCompany(e.target.value)}
                          value={company}
                          sx={{ borderRadius: "8px" }}
                        >
                          <MenuItem
                            key={userProfile.idCompany}
                            value={userProfile.companyName}
                          >
                            {userProfile.companyName}
                          </MenuItem>
                        </Select>
                      </FormControl>
                    )}
                  </Stack>
                </Grid>
                {typeOfManagement !== "delivery_sample_shuttle" ? (
                  <>
                    <Grid item xs={12} md={3} lg={3}>
                      <Stack>
                        <Text>วันที่เดินทาง</Text>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                          <DatePicker
                            value={startDate}
                            fullWidth
                            onChange={(date) => setStartDate(date)}
                            sx={{ borderRadius: "8px" }}
                            renderInput={(params) => (
                              <TextField
                                className={`${classes.DatePicker}`}
                                {...params}
                                sx={{
                                  "& .MuiOutlinedInput-root": {
                                    borderRadius: "8px",
                                  },
                                }}
                              />
                            )}
                          />
                        </LocalizationProvider>
                      </Stack>
                    </Grid>
                    <Grid item xs={12} md={3} lg={3}>
                      <Stack>
                        <Text>วันที่สิ้นสุด</Text>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                          <DatePicker
                            minDate={startDate}
                            value={endDate}
                            fullWidth
                            onChange={(date) => setEndDate(date)}
                            renderInput={(params) => (
                              <TextField
                                className={`${classes.DatePicker}`}
                                {...params}
                                sx={{
                                  "& .MuiOutlinedInput-root": {
                                    borderRadius: "8px",
                                  },
                                }}
                              />
                            )}
                          />
                        </LocalizationProvider>
                      </Stack>
                    </Grid>
                  </>
                ) : (
                  <div
                    style={{
                      paddingBlock: 10,
                      display: "flex",
                      gap: 10,
                    }}
                  >
                    <RightDrawer
                      header={"กรองการค้นหา"}
                      buttonLabel="กรองการค้นหา"
                      buttonIcon={<FilterAltIcon />}
                      isDrawerOpen={isDrawerOpen}
                      setIsDrawerOpen={setIsDrawerOpen}
                    >
                      {allEmployees && allDriver && allSite && (
                        <FilterDeliverySampleShuttle
                          allSender={allEmployees}
                          allReceiver={allEmployees}
                          allDriver={allDriver}
                          allSiteLocation={allSite}
                          onFilter={handleFilter}
                          setIsDrawerOpen={setIsDrawerOpen}
                          formDataPreviousSearch={formDataPreviousSearch}
                        />
                      )}
                    </RightDrawer>
                  </div>
                )}
              </Grid>

              <TabsStyled
                value={typeOfManagement}
                onChange={onChangeTab}
                aria-label="Tab-typeOfManagement"
                variant="scrollable"
                scrollButtons="auto"
                allowScrollButtonsMobile
              >
                <TabStyled
                  className="classes.TabLeft"
                  id="Tab-crossArea"
                  value="cross_area"
                  label="รถข้ามพื้นที่เฉพาะ"
                />
                <TabStyled
                  id="Tab-crossAreaPool"
                  value="cross_area_pool"
                  label="รถข้ามพื้นที่Pool"
                />
                <TabStyled
                  id="Tab-inArea"
                  value="in_area"
                  label="รถในพื้นที่"
                />
                <TabStyled
                  id="Tab-betweenSiteCar"
                  value="between_site_car"
                  label="รถรับส่งระหว่าง Site"
                />
                <TabStyled
                  id="Tab-peer2peer"
                  value="peer_to_peer"
                  label="รถรับส่งเพื่อน"
                />
                <TabStyled
                  id="Tab-deliveryItem"
                  value="delivery"
                  label="รถรับส่งของ"
                />
                <TabStyled
                  id="Tab-deliverySampleShuttle"
                  value="delivery_sample_shuttle"
                  label="รถรับส่งตัวอย่าง"
                />
                <TabStyled
                  id="Tab-showMapAllDriver"
                  value="showMapAllDriver"
                  label="แสดงแผนที่รถทั้งหมด"
                />
              </TabsStyled>

              <PartOfContent>
                <Switch>
                  <Route
                    exact
                    path="/admin/car_management"
                    component={() => (
                      <Redirect to="/admin/car_management/cross_area" />
                    )}
                  />

                  <Route
                    exact
                    path="/admin/car_management/cross_area"
                    component={(props) => (
                      <CrossArea
                        {...props}
                        startDate={startDate}
                        endDate={endDate}
                      />
                    )}
                  />
                  <Route
                    exact
                    path="/admin/car_management/cross_area/detail"
                    component={(props) => (
                      <DetailCrossAreaCar
                        {...props}
                        startDate={startDate}
                        endDate={endDate}
                      />
                    )}
                  />
                  <Route
                    exact
                    path="/admin/car_management/cross_area/edit_detail"
                    component={(props) => (
                      <EditDetailCrossAreaCarBooking
                        {...props}
                        startDate={startDate}
                        endDate={endDate}
                      />
                    )}
                  />

                  <Route
                    exact
                    path="/admin/car_management/cross_area_pool"
                    component={(props) => (
                      <CrossAreaPool
                        {...props}
                        startDate={startDate}
                        endDate={endDate}
                      />
                    )}
                  />
                  <Route
                    exact
                    path="/admin/car_management/cross_area_pool/detail"
                    component={(props) => (
                      <DetailCrossAreaCarPool
                        {...props}
                        startDate={startDate}
                        endDate={endDate}
                      />
                    )}
                  />
                  <Route
                    exact
                    path="/admin/car_management/cross_area_pool/edit_detail"
                    component={(props) => (
                      <EditDetailCrossAreaCarPool
                        {...props}
                        startDate={startDate}
                        endDate={endDate}
                      />
                    )}
                  />

                  <Route
                    exact
                    path="/admin/car_management/in_area"
                    component={(props) => (
                      <InArea
                        {...props}
                        startDate={startDate}
                        endDate={endDate}
                      />
                    )}
                  />
                  <Route
                    exact
                    path="/admin/car_management/in_area/detail"
                    component={(props) => (
                      <DetailInAreaCar
                        {...props}
                        startDate={startDate}
                        endDate={endDate}
                      />
                    )}
                  />
                  <Route
                    exact
                    path="/admin/car_management/in_area/edit_detail"
                    component={(props) => (
                      <EditDetailInAreaCarBooking
                        {...props}
                        startDate={startDate}
                        endDate={endDate}
                      />
                    )}
                  />

                  <Route
                    exact
                    path="/admin/car_management/delivery"
                    component={(props) => (
                      <DeliveryItems
                        {...props}
                        startDate={startDate}
                        endDate={endDate}
                      />
                    )}
                  />
                  <Route
                    exact
                    path="/admin/car_management/delivery/detail"
                    component={(props) => (
                      <DetailDeliveryCar
                        {...props}
                        startDate={startDate}
                        endDate={endDate}
                      />
                    )}
                  />
                  <Route
                    exact
                    path="/admin/car_management/delivery/edit_detail"
                    component={(props) => (
                      <EditDetailDeliveryitemCar
                        {...props}
                        startDate={startDate}
                        endDate={endDate}
                      />
                    )}
                  />

                  <Route
                    exact
                    path="/admin/car_management/delivery_sample_shuttle"
                    component={(props) => (
                      <DeliverySampleShuttleCar
                        {...props}
                        formData={formData}
                        startDate={startDate}
                        endDate={endDate}
                      />
                    )}
                  />
                  <Route
                    exact
                    path="/admin/car_management/delivery_sample_shuttle/detail"
                    component={(props) => (
                      <DetailDeliverySampleShuttle
                        {...props}
                        formData={formData}
                      />
                    )}
                  />
                  <Route
                    exact
                    path="/admin/car_management/delivery_sample_shuttle/edit_detail"
                    component={(props) => (
                      <EditDetailDeliverySampleShuttle
                        {...props}
                        startDate={startDate}
                        endDate={endDate}
                        formData={formData}
                      />
                    )}
                  />
                  <Route
                    exact
                    path="/admin/car_management/delivery_sample_shuttle/formDetailFlight"
                    component={(props) => (
                      <FormDetailFlight
                        {...props}
                        formData={formData}
                        startDate={startDate}
                        endDate={endDate}
                      />
                    )}
                  />

                  <Route
                    exact
                    path="/admin/car_management/peer_to_peer"
                    component={(props) => (
                      <DetailDriverPeer2Peer
                        {...props}
                        startDate={startDate}
                        endDate={endDate}
                      />
                    )}
                  />

                  <Route
                    exact
                    path="/admin/car_management/showMapAllDriver"
                    component={ShowMapAllDriver}
                  />

                  <Route
                    exact
                    path="/admin/car_management/between_site_car"
                    component={(props) => (
                      <BetweenSiteCarManage
                        {...props}
                        startDate={startDate}
                        endDate={endDate}
                      />
                    )}
                  />

                  <Route
                    exact
                    path="/admin/car_management/between_site_car/detail"
                    component={(props) => (
                      <DetailBetweenSite
                        {...props}
                        startDate={startDate}
                        endDate={endDate}
                      />
                    )}
                  />

                  <Route
                    exact
                    path="/admin/car_management/between_site_car/edit_detail"
                    component={(props) => (
                      <EditDetailBetweenSite
                        {...props}
                        startDate={startDate}
                        endDate={endDate}
                      />
                    )}
                  />
                </Switch>
              </PartOfContent>
            </Grid>
          </HeaderOfPage>
        </DivCoverReturn>
      </Root>
    </Container>
  );
};

export default CarManagement;
